import styled from 'styled-components'

const ButtonContentUi = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export default ButtonContentUi
